{
  "primer": {
    "eyebrow": "Orari della preghiera e Qibla",
    "headline": "Rhemn ha bisogno della tua posizione per gli orari della preghiera e la Qibla.",
    "body": "La usiamo per i tuoi orari di preghiera, la direzione della Qibla e il meteo locale — nient'altro.",
    "cta": "Continua",
    "skip": "Non ora",
    "skip_body": "Gli orari della preghiera e la Qibla resteranno disattivati."
  }
}
